var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1423_14664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1.5H5.13503L6.6082 15.1559C6.66943 15.5324 6.87453 15.8755 7.18569 16.1221C7.49686 16.3687 7.89313 16.5022 8.30149 16.4979H18.9693C19.3385 16.5158 19.7039 16.4206 20.0097 16.2268C20.3154 16.0329 20.5447 15.7511 20.6626 15.4243L22.9146 9.10944C22.9987 8.87204 23.0211 8.6194 22.9799 8.37236C22.9387 8.12532 22.8351 7.89095 22.6776 7.68859C22.5137 7.47337 22.2945 7.29992 22.0401 7.18408C21.7857 7.06825 21.5042 7.01373 21.2213 7.02552H5.72768",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6348 22.4936C17.9362 22.795 18.345 22.9643 18.7712 22.9643C19.1974 22.9643 19.6062 22.795 19.9076 22.4936C20.209 22.1922 20.3783 21.7834 20.3783 21.3571C20.3783 20.9309 20.209 20.5221 19.9076 20.2207C19.6062 19.9193 19.1974 19.75 18.7712 19.75C18.345 19.75 17.9362 19.9193 17.6348 20.2207C17.3334 20.5221 17.1641 20.9309 17.1641 21.3571C17.1641 21.7834 17.3334 22.1922 17.6348 22.4936Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49221 22.4936C6.7936 22.795 7.20239 22.9643 7.62863 22.9643C8.05487 22.9643 8.46365 22.795 8.76505 22.4936C9.06645 22.1922 9.23577 21.7834 9.23577 21.3571C9.23577 20.9309 9.06645 20.5221 8.76505 20.2207C8.46365 19.9193 8.05487 19.75 7.62863 19.75C7.20239 19.75 6.7936 19.9193 6.49221 20.2207C6.19081 20.5221 6.02148 20.9309 6.02148 21.3571C6.02148 21.7834 6.19081 22.1922 6.49221 22.4936Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1423_14664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.cfc41c06bfa207b89fec5f9ef566036b.svg";
export { ForwardRef as ReactComponent };